import React, { ReactElement } from 'react'

import {
    transformLegacyPayrollPeriodToPayrollPeriod,
} from '../../@paco/entities/PayrollPeriod/PayrollPeriodTransformers'
import { getPeriodWithoutStartOfDayCorrection } from '../../@paco/helpers/date'

import { convertDateToDateYearString } from '../../helpers/DateTimeParser'
import { PayrollPeriod } from '../../models'
import Icon from '../style/Icon/Icon'

import './PayrollPeriodNavigator.scss'

interface PayRollPeriodNavigatorProps {
    className?: string;
    payrollPeriod: PayrollPeriod;
    switchPayrollPeriod: (nextPeriod: boolean) => void;
}

export default function PayrollPeriodNavigator({
    className,
    payrollPeriod,
    switchPayrollPeriod,
}: PayRollPeriodNavigatorProps): ReactElement {
    const period = getPeriodWithoutStartOfDayCorrection(transformLegacyPayrollPeriodToPayrollPeriod(payrollPeriod).period)

    return (
        <div className={`payroll-navigator border-bottom ${className}`}>
            <div className="payroll-navigator__bottom">
                <button className="payroll-navigator__button" type="button" onClick={() => switchPayrollPeriod(false)}>
                    <Icon kind="chevron_left" />
                </button>
                <button
                    type="button"
                    className="mb-0 font-weight-semi-bold clear-button"
                >
                    {`${convertDateToDateYearString(period.start)} - 
                        ${convertDateToDateYearString(period.end)}`}
                </button>
                <button className="payroll-navigator__button" type="button" onClick={() => switchPayrollPeriod(true)}>
                    <Icon kind="chevron_right" />
                </button>
            </div>
        </div>
    )
}
